module.exports = __webpack_public_path__ + "static/media/vlplan1.b583ef31.jpeg";